export default __webpack_public_path__ + "static/media/robbery.382335c9.png";